/**
 * description:
 * dateTime: 2025/5/10-11:43
 * author: ZhangJun 1580043700@qq.com
 */

/**
 * 获取消息跳转地址
 * @param url 消息返回url
 * @param type 跳转类型
 */
export const getLink = (url: string): null | string => {
  if (!url) {
    return null
  }
  const urls = url.split(',').filter(Boolean)
  const pcUrl = replaceLink(urls, { prefix: 'pc://', replaceValue: '/' })
  const flowUrl = replaceLink(urls, { prefix: 'flow://', replaceValue: '/flow/' })
  const commonUrl = urls.find(url => url.startsWith('/')) ?? null
  const httpUrl = urls.find(url => url.startsWith('http')) ?? null
  return oldUrlFormat(pcUrl || flowUrl || commonUrl || httpUrl || '')
}

const replaceLink = (urls: Array<string>, options: { prefix: string; replaceValue: string }) => {
  const { prefix, replaceValue } = options
  const url = urls.find(url => url.startsWith(prefix)) || ''
  return url.replace(prefix, replaceValue)
}

//旧地址处理
const oldUrlFormat = (url: string) => {
  if (url) {
    if (url.includes('?clueId=')) {
      const wholeUrlList = url.split('?clueId=')
      if (wholeUrlList?.[1]) {
        url = wholeUrlList?.[0] + '/' + wholeUrlList?.[1]
      }
    }
  }
  return url
}
